import React, { useState, memo, Fragment, useEffect } from "react";
import { makeStyles } from "@mui/styles";

import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import CloseIcon from "@material-ui/icons/Close";
import GetAppIcon from "@material-ui/icons/GetApp";
import { getDictation, getIVRCallAudio } from "apiHandler/actions";
import Player from "./AudioPlayer";
import {
  IconButton,
  Snackbar,
  Slide,
  Fab,
  CircularProgress,
} from "@mui/material";
import { useUserData } from "components/customHooks/userDataContext";
import { green } from "@mui/material/colors";

const useStyles = makeStyles(() => ({
  wrapper: {
    margin: 0,
    position: "relative",
    display: "flex",
    alignItems: "center",
  },
  fabProgress2: {
    color: green[500],
    position: "absolute",
    top: -4,
    left: -4,
    zIndex: 1,
  },
  buttonClassname: {
    width: 20,
    height: 20,
  },
  downloadBtn: {
    cursor: "pointer",
  },
  snackbarContent: {
    backgroundColor: "rgb(50, 50, 50)",
    display: "flex",
    padding: "10px",
    alignItems: "center",
  },
}));

const PersonalInfoPlayer = (props) => {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [audio, setAudio] = useState(null);
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(false);
  const [mimeType, setMimeType] = useState("audio/mpeg");
  const { id, currentPlaying, setCurrentPlaying } = props;
  const userData = useUserData();
  const token = userData?.access_token;

  const { audioRef } = props;

  useEffect(() => {
    if (id !== currentPlaying) setOpen(false);
  }, [currentPlaying]);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const fetchAudio = async (download) => {
    if (id !== currentPlaying) {
      await setCurrentPlaying(id);
      await setOpen(true);
    }
    let response = audio;
    if (error) {
      setOpen(true);
      return;
    }
    if (!loading && !audio && props.id && !error) {
      if (download) setError("Download in progress...");
      else await setLoading(true);
      const payload = {
        type: "Dictation",
        search_criteria: {
          practice_id: userData.selected_practice,
          npi: props.npi,
          dictation_id: props.id,
        },
      };
      if (props.isIVRCall) {
        response = await getIVRCallAudio(
          {
            practice_id: props.practice_id.toString(),
            id: props.id.toString(),
          },
          token
        );
      } else {
        console.log("payload", payload);
        response = await getDictation(payload, token);
      }
      if (response === "ERROR" || !response) {
        setError("Failed to get the audio");
        setLoading(false);
        return;
      } else {
        await setMimeType(response.mimeType);
        await setAudio(response);
        await setError("");
      }
    }
    if (download) {
      await setCurrentPlaying(null);
      const link = document.createElement("a");
      link.href = response;
      link.setAttribute("download", `${props.id}.${props.ext || "mp3"}`);
      document.body.appendChild(link);
      link.click();
    } else {
      setLoading(false);
      await setCurrentPlaying(id);
      await setOpen(true);
    }
  };

  return (
    <div className={classes.wrapper}>
      <Fab
        aria-label="save"
        size="small"
        onClick={(event) => fetchAudio(false, event)}
        style={{
          width: 30,
          height: 30,
          minHeight: "auto",
          borderRadius: 15,
          backgroundColor: "#cb3366",
          color: "#fff",
        }}
      >
        <PlayArrowIcon className={classes.buttonClassname} />
      </Fab>
      <GetAppIcon
        color="secondary"
        onClick={(event) => fetchAudio(true, event)}
        className={classes.downloadBtn}
      />
      {loading && (
        <CircularProgress
          size={39}
          color="primary"
          className={classes.fabProgress2}
        />
      )}

      {id === currentPlaying && (audio || error) && (
        <Snackbar
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          onClose={handleClose}
          autoHideDuration={error ? 2000 : null}
          TransitionComponent={(props) => <Slide {...props} direction="up" />}
          open={open}
          sx={{ ml: 8 }}
          message={
            <div>
              {error ? (
                error
              ) : props.showPlayer ? (
                <Player audio={audio} />
              ) : (
                <audio
                  ref={audioRef}
                  src={audio}
                  type={mimeType}
                  controls
                  autoPlay
                />
              )}
            </div>
          }
          action={
            <Fragment>
              <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={() => setCurrentPlaying(null)}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            </Fragment>
          }
        />
      )}
    </div>
  );
};

export default memo(PersonalInfoPlayer);
